<div class="contacts-container padLeft20" [ngClass]="{'mobile': mediaQueryService.mobileQuery.matches}">
  <div class="contacts-array" [ngClass]="{'mobile': mediaQueryService.mobileQuery.matches}">
    <span class="greyColor margAuto contact-name curPoint" style="margin-left: 0; font-size: 14px"
          (click)="openArticleFicheEntreprise()">{{etablissement.name}}</span>
    <span class="greyColor margAuto contact-name curPoint" style="margin-left: 0; font-size: 14px"
          (click)="openArticleFicheEntreprise()">{{etablissement.adresse}}</span>
  </div>
</div>
